export enum apiMiddlewareActionTypes {
    API_CALL = "API_CALL",
    API_START = "API_START",
    API_FAILURE = "API_FAILURE",
    API_USER_FRIENDLY_EXC = "API_USER_FRIENDLY_EXC",
    API_OBJECT_NOT_FOUND = "API_OBJECT_NOT_FOUND",
    API_SUCCESS = "API_SUCCESS",
}
export enum apiCallTypes {
    MULTIPART_FORM = "MULTIPART_FORM",
}
